<div class="row" style="padding-top:1em;">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="GetVendorList()" style="display:none">Get</button>
        <button type="button" id="btn_Add" class="user-button btn btn-block btn-primary float-sm-right" (click)="showVendor()" style="display:none">Add</button>
        <table #dataTable class="display" style="width:100%"></table>
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog modal-xl custome-modal">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>
              <div class="modal-body" style="overflow-x:scroll">
                <div class="card">
                  <div class="card-body">
                    <ul class="nav nav-tabs nav-tabs-custom" id="ULTabul">
                      <li class="nav-item"><a class="nav-link active" data-toggle="tab" href="#divPrimary">Primary</a></li>
                      <li class="nav-item"><a class="nav-link " data-toggle="tab" href="#divServices">Services</a></li>
                      <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#taskDetails">Pricing</a></li>
                      <li class="nav-item"><a class="nav-link " data-toggle="tab" href="#divBankDetails">Bank Details</a></li>
                      <li class="nav-item"><a class="nav-link" data-toggle="tab" href="#divPersonal">Personal</a></li>
                    </ul>
                    <br />
                    <div class="tab-content">
                      <div class="tab-pane active" id="divPrimary">
                        <div class="form-group">
                          <button type="button" id="GetJournalListed" (click)="GetJournalList();" style="display:none">Get</button>
                          <div class="row">
                            <div class="col-sm-3">
                              <label>Name<em>*</em></label>
                              <input id="Txt_Name" type="text" class="form-control skipSpecialChar" maxlength="40" />
                            </div>
                            <div class="col-sm-3">
                              <label>Email ID<em>*</em></label>
                              <input id="Txt_EmailID" type="text" class="form-control" maxlength="40" autocomplete="off" (change)="MultipleEmail($event)" />
                            </div>
                            <div class="col-sm-3">
                              <label>Alternate Email ID</label>
                              <input id="Txt_TeamID" type="text" class="form-control " maxlength="40" (change)="MultipleEmail($event)" />
                            </div>
                            <div class="col-sm-3">
                              <label>SupplierId</label>
                              <input id="Txt_Supplier" type="number" class="form-control skipSpecialChar" maxlength="40" />
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              <label>Active<em>*</em></label>
                              <select class="form-control" id="ddlActive" name="ActiveList">
                                <option value="0" selected disabled>Select</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <label>Available<em>*</em></label>
                              <select class="form-control" id="ddlAvaliable" name="Available">
                                <option value="0" selected disabled>Select</option>
                                <option value="Yes">Yes</option>
                                <option value="No">No</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <div>
                                <label>From Date</label>
                                <input type="date" class="form-control float-right" id="Txt_From">
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div>
                                <label> To Date</label>
                                <input type="date" class="form-control float-right" id="Txt_To">
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3" style="display:none">
                              Publishers<em>*</em>
                              <select class="form-control" id="ddlPublisherList" multiple onchange="$('#GetJournalListed').trigger('click');">
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let item of publisherList" value={{item.ID}}>{{item.PublisherName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <label>Languages<em>*</em></label>
                              <select class="form-control" id="ddlLanguageList" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemL of languageList" value={{itemL.ID}}>{{itemL.Language}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <label>Source<em>*</em></label>
                              <select class="form-control" id="ddlSourceList" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemS of sourceList" value={{itemS.ID}}>{{itemS.SourceName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <label>Interest<em>*</em></label>
                              <select class="form-control" id="ddlInterestList" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemI of interestList" value={{itemI.ID}}>{{itemI.Subject}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              <label>Restriction</label>
                              <select class="form-control" id="ddlRestrictionList" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemR of restrictionList" value={{itemR.ID}}>
                                  {{itemR.Subject}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-6" style="display:none">
                              Journals
                              <select id="ddlJournalList" class="form-control" multiple>
                                <option *ngFor="let item of journalList" value={{item.ID}}>
                                  {{item.Acronym}}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-1">
                              <div class="form-group">
                                <input type="checkbox" id="JournalWisecapacity" (change)="disableTableFields($event)">&nbsp;
                                <label>JournalWise Cap</label>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <label>Capacity<em>*</em></label>
                              <input id="Txt_Capacity" type="number" class="form-control" />
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>CapacityMode</label><em>*</em>
                                <select class="form-control" id="ddlCapacityMode">
                                  <option value="Daily" selected="selected">Daily</option>
                                  <option value="Weekly">Weekly</option>
                                  <option value="Monthly">Monthly</option>
                                  <option value="Yearly">Yearly</option>
                                  <option value="Modeless">Modeless</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-3">
                              <div class="form-group">
                                <label>CapacityUnitType</label><em>*</em>
                                <select class="form-control" id="ddlCapacityUnit">
                                  <option value="Articles" selected="selected">Articles</option>
                                  <option value="Pages">Pages</option>
                                  <option value="WordCount">WordCount</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-1">
                              <div class="form-group">
                                <input type="checkbox" id="ConvertionInNT">&nbsp;
                                <span id="tickMarkDisplay"></span>
                                <label>Con.NT</label>
                              </div>
                            </div>
                            <div class="col-sm-1">
                              <div class="form-group">
                                <input type="checkbox" id="QAVendorRequired">
                                <label>QA.Required</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-12">
                              <label>Remarks</label>
                              <textarea cols="7" id="TXT_Remarks" class="form-control"></textarea>
                            </div>
                          </div><br />
                        </div>
                      </div>
                      <div class="tab-pane" id="divServices">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>Task</label>
                                <select id="ddlTaskListser" name="TaskList" class="form-select">
                                  <option *ngFor="let itemT of taskList" value={{itemT.ID}}>{{itemT.TaskName}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>Journal</label>
                                <select id="ddlJournalListService" name="Journal" class="form-control" multiple>
                                  <option *ngFor="let item of journalList" value={{item.ID}}>{{item.Acronym}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <label>vendorType<em>*</em></label>
                              <select class="form-control" id="ddlvendortype" name="VendorType">
                                <option value="Primary">Primary</option>
                                <option value="Secondary">Secondary</option>
                              </select>
                        </div>
                            <div class="col-sm-2">
                              <label>Languages<em>*</em></label>
                              <select class="form-control" id="ddlLanguageListSer" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemL of languageList" value={{itemL.ID}}>{{itemL.Language}}</option>
                              </select>
                            </div>
                            <div class="col-sm-2">
                              <label>Source<em>*</em></label>
                              <select class="form-control" id="ddlSourceListSer" multiple>
                                <!--<option value="0">All</option>-->
                                <option *ngFor="let itemS of sourceList" value={{itemS.ID}}>{{itemS.SourceName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <button type="button" class="btn btn-outline-success waves-effect waves-light clsMargin" title="Add" id="btnAddTask" (click)="AddServiceTaskRow()">Add</button>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="col-sm-12">
                              <table id="tblTaskSer" class="tblTrans table" width="100%">
                                <thead>
                                  <tr>
                                    <th class="textAlign" style="width: 5%;" >S.No.</th>
                                    <th class="textAlign" >Task Name</th>
                                    <th class="textAlign" >Journal</th>
                                    <th class="textAlign" >VendorType</th>
                                    <th class="textAlign">Languages</th>
                                    <th class="textAlign">Source</th>
                                    <th>Capacity</th>
                                    <th>CapacityUnit</th>
                                    <th>CapacityMode</th>
                                    <th class="textAlign" style="width: 3%;">#</th>
                                  </tr>
                                  <!--<tr>
                                    <th>Price</th>
                                    <th>Capacity</th>
                                    <th>Price</th>
                                    <th>Capacity</th>
                                    <th>Price</th>
                                    <th>Capacity</th>
                                  </tr>-->
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div id="taskDetails" class="tab-pane">
                        <div class="col-sm-12" id="divMainFilter">
                          <div class="row">
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>Task</label>
                                <select id="ddlTaskList" name="TaskList" class="form-select">
                                  <option *ngFor="let itemT of taskList" value={{itemT.ID}}>{{itemT.TaskName}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>Journal</label>
                                <select id="ddlJournal" name="Journal" class="form-control" multiple>
                                  <option *ngFor="let item of journalList" value={{item.ID}}>{{item.Acronym}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-2" style="display:none">
                              <label>Team</label>
                              <input id="Txt_Team" type="number" class="form-control" min="0" />&nbsp;
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <label>PriceType</label><em>*</em>
                                <select class="form-control" id="ddlPriceType">
                                  <option value="INR">INR</option>
                                  <option value="USD">USD</option>
                                  <option value="GBP">GBP</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-sm-2">
                              <div class="form-group">
                                <button type="button" class="btn btn-outline-success waves-effect waves-light clsMargin" title="Add" id="btnAddTask" (click)="AddTaskRow()">Add</button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col">
                          <div class="col-sm-12">
                            <table id="tblTask" class="tblTrans table" width="50%">
                              <thead>
                                <tr>
                                  <th rowspan="2" class="textAlign">S.No.</th>
                                  <th rowspan="2" class="textAlign" style="width: 6%;">Task Name</th>
                                  <th rowspan="2" class="textAlign" style="width: 6%;">Journal</th>
                                  <th rowspan="2" class="textAlign" style="width: 6%;">PriceType</th>
                                  <th colspan="2">Article</th>
                                  <th colspan="2">Page</th>
                                  <th colspan="2">Word</th>
                                  <th colspan="2">Table</th>
                                  <th colspan="2">Figure</th>
                                  <th rowspan="2" class="textAlign">#</th>
                                </tr>
                                <tr>
                                  <th>Price</th>
                                  <th>Capacity</th>
                                  <th>Price</th>
                                  <th>Capacity</th>
                                  <th>Price</th>
                                  <th>Capacity</th>
                                  <th>Price</th>
                                  <th>Capacity</th>
                                  <th>Price</th>
                                  <th>Capacity</th>
                                </tr>
                              </thead>
                              <tbody></tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="divBankDetails">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              <b style="font-size: 14px;">Bank details</b>
                            </div>
                          </div>
                          <hr>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-4">
                                  Bank Name
                                  <input type="text" class="form-control" id="Txt_BankName" />
                                </div>
                                <div class="col-sm-4">
                                  Account No.
                                  <input type="text" class="form-control IsNumeric" id="Txt_AccNo" />
                                </div>
                                <div class="col-sm-4">
                                  IFSC Code
                                  <input type="text" class="form-control" id="Txt_IFSC" />
                                </div>
                              </div>
                            </div>
                            <div class="form-group">
                              <div class="row">
                                <div class="col-sm-4">
                                  Branch Name
                                  <input type="text" class="form-control" id="Txt_Branch" />
                                </div>
                                <div class="col-sm-4">
                                  NDA Document
                                  <select class="form-control" id="ddlNDAdoc">
                                    <option value="0" selected disabled>Select</option>
                                    <option value="Signed">Signed</option>
                                    <option value="UnSigned">UnSigned</option>
                                    <option value="NoNeed">NoNeed</option>
                                  </select>
                                </div>
                                <div class="col-sm-4">
                                  PAN Card
                                  <input type="text" class="form-control" id="Txt_PAN" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="divPersonal">
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              <b style="font-size: 14px;">Personal Info</b>
                            </div>
                          </div>
                          <hr>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              Secondary Email ID
                              <input type="text" class="form-control" id="Txt_AltEmailID" maxlength="40" autocomplete="off" (change)="MultipleEmail($event)" />
                            </div>
                            <div class="col-sm-3">
                              Mobile No.
                              <input type="text" id="Txt_mobile" class="form-control IsNumeric" maxlength="10">
                              <!--<input type="number" class="form-control" id="Txt_mobile" />-->
                            </div>
                            <div class="col-sm-3">
                              DOB
                              <input type="date" name="DOB" class="form-control float-right" id="Txt_DOB" autocomplete="off" (change)="Dobdatevalidation($event)">
                              <!--<input type="Date" class="form-control" id="Txt_DOB" />-->
                            </div>
                            <div class="col-sm-3">
                              Gender
                              <select class="form-control" id="ddlGender">
                                <option value="0" selected disabled>Select</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              Fascimile
                              <input type="text" class="form-control" id="Txt_fascimile" />
                            </div>
                            <div class="col-sm-3">
                              Address
                              <textarea class="form-control" id="Txt_address"></textarea>
                            </div>
                            <div class="col-sm-3">
                              Pincode
                              <input type="text" class="form-control IsNumeric" id="Txt_pincode" maxlength="6" />
                            </div>
                            <div class="col-sm-3">
                              Web Link
                              <input type="text" class="form-control" id="Txt_weblink" />
                            </div>

                          </div>
                        </div>
                        <div class="form-group">
                          <div class="row">
                            <div class="col-sm-3">
                              Country
                              <select class="form-control" id="ddlCountry" (change)="GetState(0)">
                                <option value="0" disabled selected>Select Country</option>
                                <option *ngFor="let itemC of CountryList" value={{itemC.ID}}>{{itemC.CountryName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              State
                              <select class="form-control" id="ddlState" (change)="GetCity(0,0)">
                                <option value="0" disabled selected>Select State</option>
                                <option *ngFor="let itemS of StateList" value={{itemS.ID}} [selected]="itemS.ID==StateIDPop">{{itemS.StateName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              City
                              <select class="form-control" id="ddlCity">
                                <option value="0" disabled selected>Select City</option>
                                <option *ngFor="let itemCT of CityList" value={{itemCT.ID}} [selected]="itemCT.ID==CityidPop">{{itemCT.CityName}}</option>
                              </select>
                            </div>
                            <div class="col-sm-3">
                              Web Address
                              <input type="text" class="form-control" id="Txt_Webaddress" />
                            </div>
                          </div>
                        </div>

                        <div class="col-sm-4 profile">
                          <div class="input-group" style="text-align:center;">
                            <img src="../../../assets/Images/userLogo.jpg" alt="Profile" style="height:110px;width:110px;margin-top:10px;border-radius:10px;" id="imgProfile" (error)="onerrorImageLoad()" /> <br /><br />
                            <input type="file" name="file" id="imageUploadForm" style="width: 100%;margin-left:10px" class="btn" (change)="showPreview($event)" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="submit" (click)="AddUpdateVendor()" class="btn btn-outline-success waves-effect waves-light">{{popUpButtonText}}</button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
